export const VideowallConfig = () => {
    return(
        <div style={{height: '20%', width: '20%', backgroundColor: 'red'}}>
            Deloitte
        </div>
    )
}